import Collapse from "@mui/material/Collapse";
import Fade from "@mui/material/Fade";
import type { HTMLAttributes } from "react";
import { useLayoutEffect, useState } from "react";
import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";
import { classList } from "~lib/classList.ts";

import s from "./Spinner.module.scss";

interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
  container?: "inPage" | "fullScreen";
  showMoreInfoTimeout?: number;
}

export function Spinner({
  loading = true,
  showMoreInfoTimeout = 3000,
  container = "fullScreen",
  className,
  ...props
}: SpinnerProps) {
  const t = useTranslation();
  const [showMoreInfo, setShowMoreInfo] = useState(false);

  useLayoutEffect(() => {
    const timeout = loading
      ? setTimeout(() => {
          setShowMoreInfo(true);
        }, showMoreInfoTimeout)
      : undefined;

    return () => clearTimeout(timeout);
  }, [loading, showMoreInfoTimeout]);

  return (
    <Fade in={loading}>
      <div
        role="progressbar"
        aria-valuemax={0}
        aria-valuemin={0}
        aria-valuenow={0}
        tabIndex={-1}
        className={classList(className, s.container, s[container])}
        {...props}
      >
        <div className={s.animation}>
          <img src="/rasenmaeher.svg" alt="" />
          <img src="/rasenmaeher.svg" alt="" />
          <img src="/rasenmaeher.svg" alt="" />
        </div>
        <Collapse in={showMoreInfo}>
          <p className={s.info}>{t.moreLoadingInfo}</p>
        </Collapse>
      </div>
    </Fade>
  );
}
